/* src/app/order/components/estimate-questions/estimate-questions.style.scss */
form {
  margin-bottom: 40px;
}
@media screen and (max-width: 767px) {
  form {
    margin-top: 40px;
  }
}
/*# sourceMappingURL=estimate-questions.style.css.map */
